<div class="batch-header flex justify-space-between">
    <div class="admin-header">
        <h2 class="heading">Deleted Batch Alert</h2>
    </div>
    
</div>

<section class="error-wrapper" *ngIf="batchAlertService.deletedBatchAlertErrMsg">
    <f-alert variant="error">
        <p>
            There was problem loading the data. <a  href="javascript:void('0')" (click)="batchAlertService.getDataforDeletedBatchAlert(batchAlertService.clientId)"class="btn-alert">Try again.</a>
        </p>
    </f-alert>

</section>



<div class="delete-batch-table">
    <app-alight-table class="delete-table" [dataSource]="batchAlertService.deletedBatchAlertData" [totalRecords]="totalRecords" [gridColumns]="batchAlertService.deleteColumns"
                            [tableName]="'deleteTable'" [rowPerPage]="10" (rowSelection)="rowSelection($event)"
                            [isShowButtons]="false"></app-alight-table>                       
                        
</div>